export enum OfferUnavailableReason {
  SOLD_OUT = 'SOLD_OUT',
  CAPACITY_EXCEEDED = 'CAPACITY_EXCEEDED',
  DATE_UNAVAILABLE = 'DATE_UNAVAILABLE',
  NUM_NIGHTS_UNSUPPORTED = 'NUM_OF_NIGHTS_UNSUPPORTED',
  NO_PRICES_FOUND = 'NO_PRICES_FOUND'
}

export const ELIGIBLE_FOR_HOTEL_LOYALTY_POINTS_INCLUSION_DESCRIPTION = 'Eligible for hotel loyalty points'

// Mapping of property chain names to their loyalty program names
export const CHAIN_NAME_TO_LOYALTY_PROGRAM: Record<string, string> = {
  'Accor': 'Accor Live Limitless',
  'Best Western': 'Best Western Rewards',
  'Choice Hotels International': 'Choice Privileges',
  'EVT': 'EVT Stays',
  'Hyatt Hotels': 'World of Hyatt',
  'IHG': 'IHG One Rewards',
  'Minor Hotels': 'GHA Discovery',
  'Pan Pacific Hotels & Resorts': 'GHA Discovery',
  'Radisson Hotel Group': 'Radisson Rewards',
  'Wyndham Hotels & Resorts': 'Wyndham Rewards',
}

// Mapping of property chain IDs to their loyalty program names
export const CHAIN_ID_TO_LOYALTY_PROGRAM: Record<string, string> = {
  '0012800000cuN6wAAE': 'Accor Live Limitless',
  '0010I00002FAEFyQAP': 'Best Western Rewards',
  '00128000007TC47AAG': 'EVT Stays',
  '0012800000cuJr4AAE': 'World of Hyatt',
  '00128000005hFxHAAU': 'IHG One Rewards',
  '0012800000sJIiqAAG': 'GHA Discovery',
  '00128000005cKXBAA2': 'GHA Discovery',
  '0012800000jAJ49AAG': 'Radisson Rewards',
  '0012800001Y2o9rAAB': 'Wyndham Rewards',
  '00128000005cTe6AAE': 'Wyndham Rewards', // This chain id is for Ovolo Group, which is under the Wyndham Rewards
}
